const DashboardAlerts = ({ alerts=[] }) => {

    if(!alerts.length) return null;

    return (

        <div className="bg-red-50 rounded-xl border border-red-200 p-5">

            <h2 className="font-semibold text-red-600 mb-3">

                🚨 Alerts

            </h2>

            {

                alerts.map((item,index)=>

                    <div
                        key={index}
                        className="mb-2"
                    >

                        • {item}

                    </div>

                )

            }

        </div>

    );

};

export default DashboardAlerts;